import { useState, useRef } from 'react';
import PersonalInfoSection from './PersonalInfoSection';
import SuccessMessage from './SuccessMessage';
import ErrorMessage from './ErrorMessage';
import FormLayout from './FormLayout';
import SubmitButton from './SubmitButton';
import useFormSubmission from '../hooks/useFormSubmission';

function Stage2Page({ formData, token }) {
  const formRef = useRef();
  const [formPersonalInfo, setFormPersonalInfo] = useState(formData);
  const [errors, setErrors] = useState({});
  const { loading, success, submitError, handleSubmit } = useFormSubmission(formRef, token, 'stage_2');

  const handlePersonalInfoChange = (field, value) => {
    setFormPersonalInfo(prev => ({ ...prev, [field]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formPersonalInfo.customer_name) newErrors.customer_name = 'Påkrævet';
    if (!formPersonalInfo.mail) newErrors.mail = 'Påkrævet';
    return newErrors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    
    const result = await handleSubmit(formPersonalInfo, validate);
    if (!result.success && result.errors) {
      setErrors(result.errors);
    }
  };

  if (success) return <SuccessMessage />;

  return (
    <FormLayout title="Etape 2 Formular" ref={formRef} onSubmit={onSubmit}>
      <PersonalInfoSection
        values={formPersonalInfo}
        onChange={handlePersonalInfoChange}
        errors={errors}
        isLocked={!!token}
      />
      {submitError && <ErrorMessage message={submitError} />}
      <SubmitButton
        loading={loading}
        buttonText="Send Etape 2"
        loadingText="Sender..."
      />
    </FormLayout>
  );
}

export default Stage2Page;